import { ACTION_PREFIX, FAVOURITE_GAMES_ACTION_TYPE } from "./favourite-games.action";

export const FAVOURITE_GAMES_MESSAGE_CONTEXT = {
	addRemove: `${ACTION_PREFIX} Add Remove`,
	error: `${ACTION_PREFIX} Error`,
	getAll: FAVOURITE_GAMES_ACTION_TYPE.getAll,
	add: FAVOURITE_GAMES_ACTION_TYPE.add,
	remove: FAVOURITE_GAMES_ACTION_TYPE.remove,
};
